<div>
@let mode = $mode();
@switch (mode) {
    @case ('empty') {
        <span i18n>Empty</span>
    }
    @case ('loading') {
        <span i18n>Loading</span>
    }
    @case ('generating') {
        @let reportForm = $reportForm();
        @if (reportForm) {
            <risr-form-renderer [risrForm]="reportForm"></risr-form-renderer>
            <button type="button" matButton="outlined" color="primary" (click)="generate()" i18n>Generate</button>
        }
    }
    @case ('ready') {
        @let report = $currentReport();
        @let reportRunResponse = resultModel().reportResult;

        @if (report && reportRunResponse) {
            <risr-features-reports-report-result></risr-features-reports-report-result>
        }

        @if (!readOnly()) {
            <button type="button" matButton="outlined" color="primary" (click)="regenerate()" i18n>Update report</button>
        }
    }
    @case ('error') {
        <p class="box box-warning">{{ $error()?.message || $error() }}</p>
        @if (!readOnly()) {
            <button type="button" matButton="outlined" color="primary" (click)="regenerate()" i18n>Update report</button>
        }
    }
}
</div>
